import { createFileRoute } from '@tanstack/react-router';

import { ContractsPage } from '@/features/contracts/components/contracts-page';

export const Route = createFileRoute('/_app/contratos/')({
  component: ContractsPage,
});
